<mable-banner
  category="headed-callout"
  heading="Rates info"
  icon="information-circle"
  data-testid="rate-info-banner"
>
  <div class="content">
    <p data-testid="rate-info-banner-content">{{ feeInfoText }} {{ bannerText }}</p>
    <mable-button
      class="ion-no-padding"
      category="link"
      (onClick)="openServiceCategoryLink()"
    >
      More info about service categories
    </mable-button>
  </div>
</mable-banner>
